import type { JsonBody, SuccessResponse } from './openapi-helpers';
import type { paths } from './openapi-schema';

export const LOGIN_OPERATION = {
  method: 'post',
  path: '/api/v1/users/login',
  source: 'http://localhost:3000/api-docs/v1/swagger.json',
} as const;

type LoginOperation =
  paths[typeof LOGIN_OPERATION.path][typeof LOGIN_OPERATION.method];

type LoginRequestBody = LoginOperation['requestBody'];
type LoginResponses = Pick<LoginOperation['responses'], 200>;

export type GeneratedLoginRequest = JsonBody<LoginRequestBody>;
export type GeneratedLoginResponse = SuccessResponse<LoginResponses>;

export type GeneratedAuthSessionResponse = GeneratedLoginResponse;

export const CURRENT_USER_OPERATION = {
  method: 'get',
  path: '/api/v1/users/user',
  source: 'http://localhost:3000/api-docs/v1/swagger.json',
} as const;

type CurrentUserOperation =
  paths[typeof CURRENT_USER_OPERATION.path][typeof CURRENT_USER_OPERATION.method];

type CurrentUserRequestBody = never;
type CurrentUserResponses = Pick<CurrentUserOperation['responses'], 200>;

export type GeneratedCurrentUserRequest = JsonBody<CurrentUserRequestBody>;
export type GeneratedCurrentUserResponse = SuccessResponse<CurrentUserResponses>;

export const UPDATE_CURRENT_USER_OPERATION = {
  method: 'patch',
  path: '/api/v1/users/user',
  source: 'http://localhost:3000/api-docs/v1/swagger.json',
} as const;

type UpdateCurrentUserOperation =
  paths[typeof UPDATE_CURRENT_USER_OPERATION.path][typeof UPDATE_CURRENT_USER_OPERATION.method];

type UpdateCurrentUserRequestBody = UpdateCurrentUserOperation['requestBody'];
type UpdateCurrentUserResponses = Pick<UpdateCurrentUserOperation['responses'], 200>;

export type GeneratedUpdateCurrentUserRequest = JsonBody<UpdateCurrentUserRequestBody>;
export type GeneratedUpdateCurrentUserResponse = SuccessResponse<UpdateCurrentUserResponses>;

export const UPDATE_CURRENT_USER_PASSWORD_OPERATION = {
  method: 'patch',
  path: '/api/v1/users/password',
  source: 'http://localhost:3000/api-docs/v1/swagger.json',
} as const;

type UpdateCurrentUserPasswordOperation =
  paths[typeof UPDATE_CURRENT_USER_PASSWORD_OPERATION.path][typeof UPDATE_CURRENT_USER_PASSWORD_OPERATION.method];

type UpdateCurrentUserPasswordRequestBody = UpdateCurrentUserPasswordOperation['requestBody'];
type UpdateCurrentUserPasswordResponses = Pick<UpdateCurrentUserPasswordOperation['responses'], 200>;

export type GeneratedUpdateCurrentUserPasswordRequest = JsonBody<UpdateCurrentUserPasswordRequestBody>;
export type GeneratedUpdateCurrentUserPasswordResponse = SuccessResponse<UpdateCurrentUserPasswordResponses>;

export const FORGOT_PASSWORD_OPERATION = {
  method: 'post',
  path: '/api/v1/users/password/forgot',
  source: 'http://localhost:3000/api-docs/v1/swagger.json',
} as const;

type ForgotPasswordOperation =
  paths[typeof FORGOT_PASSWORD_OPERATION.path][typeof FORGOT_PASSWORD_OPERATION.method];

type ForgotPasswordRequestBody = ForgotPasswordOperation['requestBody'];

export type GeneratedForgotPasswordRequest = JsonBody<ForgotPasswordRequestBody>;

export const RESET_PASSWORD_OPERATION = {
  method: 'patch',
  path: '/api/v1/users/password/reset',
  source: 'http://localhost:3000/api-docs/v1/swagger.json',
} as const;

type ResetPasswordOperation =
  paths[typeof RESET_PASSWORD_OPERATION.path][typeof RESET_PASSWORD_OPERATION.method];

type ResetPasswordRequestBody = ResetPasswordOperation['requestBody'];
type ResetPasswordResponses = Pick<ResetPasswordOperation['responses'], 200>;

export type GeneratedResetPasswordRequest = JsonBody<ResetPasswordRequestBody>;
export type GeneratedResetPasswordResponse = SuccessResponse<ResetPasswordResponses>;

